import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { AppLayout } from './components/layout/AppLayout'
import { ErrorPage } from './pages/ErrorPage'
import { ForbiddenPage } from './pages/ForbiddenPage'
import { InviteRequiredPage } from './pages/InviteRequiredPage'
import { LoginPage } from './pages/LoginPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { RpaCredentialsPage } from './pages/RpaCredentialsPage'
import { SignUpPage } from './pages/SignUpPage'
import { ChatPage } from './pages/rag/ChatPage'
import { DocumentDetailPage } from './pages/rag/DocumentDetailPage'
import { DocumentsPage } from './pages/rag/DocumentsPage'
import { PageTransitionOutlet } from './routes/PageTransitionOutlet'
import { ProtectedRoute } from './routes/ProtectedRoute'
import { PermissionGate } from './routes/PermissionGate'
import { RootRedirect } from './routes/RootRedirect'
import './App.css'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PageTransitionOutlet />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/invite-required" element={<InviteRequiredPage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/forbidden" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route element={<PageTransitionOutlet />}>
                <Route path="/" element={<RootRedirect />} />
                <Route
                  path="/rag/chat"
                  element={
                    <PermissionGate permission="rag:search">
                      <ChatPage />
                    </PermissionGate>
                  }
                />
                <Route
                  path="/rag/documents"
                  element={
                    <PermissionGate permission="rag:search">
                      <DocumentsPage />
                    </PermissionGate>
                  }
                />
                <Route
                  path="/rag/documents/:id"
                  element={
                    <PermissionGate permission="rag:search">
                      <DocumentDetailPage />
                    </PermissionGate>
                  }
                />
                <Route
                  path="/settings/rpa-credentials"
                  element={
                    <PermissionGate permission="rpa:credentials:manage">
                      <RpaCredentialsPage />
                    </PermissionGate>
                  }
                />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
